<template>
   <div
      v-if="shouldShow"
      id="intercom-facade"
      class="fixed bottom-[20px] z-[9999] right-[20px] pointer-events-auto"
      style="z-index: 2147483647"
   >
      <button
         id="open-intercom"
         style="z-index: 2147483647"
         class="rounded-full p-3.5 flex items-center relative z-10 justify-center bg-[#228ae6] transition-transform duration-200 hover:scale-105 pointer-events-auto"
         title="Start een chat met onze klantenservice"
         @click="handleIntercomClick"
      >
         <div class="flex items-center justify-center">
            <svg
               id="intercom-icon"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 28 32"
               class="w-6 h-6 fill-white"
            >
               <path
                  d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"
               />
            </svg>
            <!-- <svg
               id="intercom-spinner"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               class="w-6 h-6 fill-white animate-spin"
               :class="{ hidden: !isLoading }"
            >
               <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg> -->
         </div>
      </button>
   </div>
</template>

<script setup>
const inBrowser = typeof window !== 'undefined'

import { onMounted, computed, onUnmounted, ref } from 'vue'
const isLoading = ref(false)
const shouldShow = computed(() => {
   if (!inBrowser) return false

   return window.env === 'production' || window.env === 'local'
})

onMounted(() => {
   if (!inBrowser) return

   window.mitt.on('open-intercom', handleIntercomClick)
})

onUnmounted(() => {
   if (!inBrowser) return

   window.mitt.off('open-intercom', handleIntercomClick)
})

const loadIntercom = () => {
   if (!inBrowser) return
   isLoading.value = true

   if (window.Intercom && typeof window.Intercom === 'function') {
      window.Intercom('show')
      return
   }

   const w = window
   const d = document
   const i = function () {
      i.c(arguments)
   }
   i.q = []
   i.c = function (args) {
      i.q.push(args)
   }
   w.Intercom = i

   const s = d.createElement('script')
   s.type = 'text/javascript'
   s.async = true
   s.src = 'https://widget.intercom.io/widget/i2p3nmsz'
   s.onload = () => {
      window.Intercom('show')
      document.getElementById('intercom-facade').style.display = 'none'
   }
   const x = d.getElementsByTagName('script')[0]
   x.parentNode.insertBefore(s, x)
}

const handleIntercomClick = () => {
   localStorage.setItem('chatStarted', true)
   if (window.Intercom && typeof window.Intercom === 'function') {
      window.Intercom('show')
      document.getElementById('intercom-facade').style.display = 'none'
   } else {
      loadIntercom()
   }
}
</script>
